import PacingBoardStatusBadge from './pacing-board-status-badge';
import type { PacingBoardAlert } from '../../types/pacing-board.types';

interface PacingAlertsPanelProps {
  alerts: PacingBoardAlert[];
  onSelectBudget: (budgetId: string) => void;
}

export default function PacingAlertsPanel({ alerts, onSelectBudget }: PacingAlertsPanelProps) {
  if (alerts.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center bg-[#F4F5F8] p-8 text-sm text-[#9CA3AF]">
        No pacing alerts — all budgets are on track or not yet started.
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto bg-[#F4F5F8] p-6">
      <div className="mx-auto max-w-3xl space-y-3">
        {alerts.map((alert) => (
          <button
            key={alert.budget_id}
            type="button"
            onClick={() => onSelectBudget(alert.budget_id)}
            className="w-full rounded-xl border border-[#EDEEF2] bg-white p-4 text-left transition-colors hover:border-[#D9DBE3] hover:bg-[#F7F8FA]"
          >
            <div className="mb-2 flex items-center justify-between gap-3">
              <div>
                <div className="text-sm font-semibold text-[#0D0F1A]">{alert.campaign_name}</div>
                <div className="text-xs text-[#5E6278]">{alert.client_name}</div>
              </div>
              <PacingBoardStatusBadge status={alert.status} />
            </div>
            <p className="text-sm text-[#5E6278]">{alert.alert_text}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
